import script from "./QwoachDialog.vue?vue&type=script&lang=js"
export * from "./QwoachDialog.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__